import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from 'src/components/Button';
import Iconify from 'src/components/iconify';

const TableHeader = ({
  onCreateUser,
  count,
  onMessageAll,
  onExportUsers,
  onInviteVolunteers,
  userCount = 0,
  loading,
}) => {
  return (
    <Stack p={2} direction="row" alignItems="baseline">
      <Stack spacing={1.5}>
        <Box sx={{ typography: 'body2' }}>
          <strong>{count}</strong>
          <Box component="span" sx={{ color: 'text.secondary', ml: 0.25 }}>
            {' active users'}
          </Box>
        </Box>
      </Stack>
      <Stack direction={'row'} gap={2} justifyContent={'flex-end'} alignItems={'center'} flex={1}>
        {onMessageAll ? (
          <Button
            onClick={onMessageAll}
            variant="outlined"
            color="inherit"
            disabled={loading}
            startIcon={<Iconify icon="solar:chat-round-dots-bold" />}
            sx={{ display: 'inline-flex', alignItems: 'center', px: 2 }}
          >
            Message All
          </Button>
        ) : null}
        {onExportUsers ? (
          <Button
            onClick={onExportUsers}
            variant="outlined"
            color="inherit"
            disabled={loading || !userCount}
            startIcon={<Iconify icon="solar:download-minimalistic-bold" />}
            sx={{ display: 'inline-flex', alignItems: 'center', px: 2 }}
          >
            Export Users
          </Button>
        ) : null}
        {onInviteVolunteers ? (
          <Button
            onClick={onInviteVolunteers}
            variant="outlined"
            color="inherit"
            startIcon={<Iconify icon="solar:qr-code-bold" />}
            sx={{ display: 'inline-flex', alignItems: 'center', px: 2 }}
          >
            Invite Volunteers
          </Button>
        ) : null}
        <Button onClick={onCreateUser} color="inherit">
          New User
        </Button>
      </Stack>
    </Stack>
  );
};

export default TableHeader;
